
const now = () => (new Date()).getTime();

export const getFromLocalStorage = (key) => {
    let entry = window.localStorage.getItem(key);
    if (!entry || entry === undefined || entry === "undefined") {
        return null;
    }
    let entry_data = JSON.parse(entry);
    let expiry = entry_data.now + entry_data.ttl;

    if (entry_data.ttl && expiry < now()) {
        window.localStorage.removeItem(key);
        return null;
    }
    return entry_data.value;
}
//will keep item for 10mins where ttl is not provided
export const setLocalStorage = (key, value, ttl) => {
    window.localStorage.setItem(key, JSON.stringify({
        ttl: ttl || 2629800000,
        now: now(),
        value: value
    }));
}
export const removeItem = (key) => {
    window.localStorage.removeItem(key);
}


export const setTrackingData = (data) => {

    let utm_source = getFromLocalStorage('utm_source')

    let utm_campaign = getFromLocalStorage('utm_campaign')

    if (utm_source !== null) {
        data.utm_source = utm_source
    }

    let bTag = getFromLocalStorage('btag')

    if (bTag !== null) {
        data.btag = bTag;
    }

    if (utm_campaign !== null) {
        data.utm_campaign = utm_campaign
    }

    return data
}

export const clearTrackingData = () => {
    setLocalStorage('utm_source', null)
    setLocalStorage('utm_campaign', null)
}